import React from 'react'
import {Button} from "antd";
import {ArrowForwardRounded, InsertChartOutlinedRounded} from "@mui/icons-material";

const CardButton = ({ onClickFn, cardTitle, cardIcon }) => {
    return(
        <Button className={'ch-card-button'} onClick={onClickFn}>
            <p>{cardTitle}</p>
            <div>
                {cardIcon && cardIcon}
                <ArrowForwardRounded fontSize={"large"} />
            </div>
        </Button>
    )
}

export default CardButton;